import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { resendVerification } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { EnvelopeOpen, X } from "@phosphor-icons/react";

export default function VerifyBanner() {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (!user || user.email_verified || dismissed) return null;

  const resend = async () => {
    setBusy(true);
    try {
      await resendVerification();
      toast.success("Verification email re-sent — check your inbox");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to resend");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="bg-[hsl(var(--accent))] text-white border-b border-foreground"
      data-testid="verify-banner"
    >
      <div className="max-w-screen-2xl mx-auto px-6 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <EnvelopeOpen size={18} weight="fill" className="shrink-0" />
          <div className="text-xs sm:text-sm font-mono leading-snug">
            <span className="font-bold uppercase tracking-widest mr-2">Verify your email.</span>
            <span className="opacity-90">
              We sent a link to <strong>{user.email}</strong>. You can use the app, but subscribing is blocked until you verify.
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button
            variant="outline"
            onClick={resend}
            disabled={busy}
            className="rounded-none border-2 border-white text-white bg-transparent hover:bg-white hover:text-foreground h-8 px-3 font-mono text-[10px] uppercase tracking-widest"
            data-testid="verify-banner-resend"
          >
            {busy ? "Sending…" : "Resend"}
          </Button>
          <button
            onClick={() => setDismissed(true)}
            className="text-white/80 hover:text-white"
            data-testid="verify-banner-dismiss"
            title="Dismiss"
          >
            <X size={14} weight="bold" />
          </button>
        </div>
      </div>
    </div>
  );
}
